import * as React from 'react'
import {DragControl, dragPropsFromCtl} from '@containers/hooks-draggable'

const customClass = 'custom-dragged'

const setClass = (target: HTMLDivElement) => {
  if (target && !target?.className?.includes(customClass)) {
    target.classList.add(customClass)
  }
}

const removeClass = (target: HTMLDivElement) => {
  if (target?.className?.includes(customClass)) {
    target.classList.remove(customClass)
  }
}

export const useOnDrag = <T,>(itemId: T, dragCtl: DragControl<T>) => {
  const handlers = dragPropsFromCtl(itemId, dragCtl, 'move')
  const {onDragStart, onDragEnd, ...restHandlers} = handlers

  const onDragStartEx = (e: React.DragEvent) => {
    const target = e.target as HTMLDivElement
    setClass(target)
    onDragStart(e)
  }

  const onDragEndEx = (e: React.DragEvent) => {
    onDragEnd(e)
    const target = e.target as HTMLDivElement
    removeClass(target)
  }

  return {
    onDragStart: onDragStartEx,
    onDragEnd: onDragEndEx,
    ...restHandlers
  }
}
